<div>
  <app-aaos-education-institution [applicationCountries]="applicationCountries" *ngFor="let educationInstitution of institutionDetails" [dynamicForm] = "dynamicForm" [institutionDetail]="educationInstitution" (componentChanged)="onComponentChange($event)" [fieldsPrerequisite]="fieldsPrerequisite"></app-aaos-education-institution>
</div>
<button class="btn btn--solid" (click)="addInstitution()">ADD INSTITUTION</button>
